@import "~/styles/variables";

.Field {
  &_inline {
    display: flex;

    .Meta {
      flex-shrink: 0;
      margin-right: $space-xs;
      width: 85px;
    }

    &.Field_s .Meta {
      padding-top: 6px;
    }

    &.Field_m .Meta {
      padding-top: 10px;
    }

    &.Field_l {
      .Meta {
        padding-top: 14px;
      }

      &.Field_compact .Meta {
        padding-top: 17px;
      }
    }
  }
}
